import type { Membership } from '@/features/auth/session';

/** Each page and action this app protects, with the permissions it needs.
 *  This is the one place that gives a permission id. */
export const ACCESS = {
  campaignsPage: ['campaign:view'],
  campaignManage: ['campaign:manage'],
  brandsPage: ['brand_hub:brand:view'],
  brandManage: ['brand_hub:brand:manage'],
  templatesPage: ['brand_hub:template:view'],
  templateCreate: ['brand_hub:template:edit'],
  templateUpdate: ['brand_hub:template:edit'],
  templateDelete: ['brand_hub:template:delete'],
  savedElementsPage: ['brand_hub:saved_element:view'],
  savedElementEdit: ['brand_hub:saved_element:edit'],
  savedElementDelete: ['brand_hub:saved_element:delete'],
} as const satisfies Record<string, readonly string[]>;

export type Action = keyof typeof ACCESS;

/** Returns true if the membership has all the permissions of the action.
 *  The role gives no permission. */
export function can(membership: Membership | null, action: Action | undefined): boolean {
  if (!action) return true;
  if (!membership) return false;
  return ACCESS[action].every((permission) => membership.permissions.includes(permission));
}
